(() => {
  const setup = root => {
    if (!root || root.dataset.bbFiltersReady) return;
    root.dataset.bbFiltersReady = 'true';
    const cards = [...root.querySelectorAll('[data-bb-filter-card]')];
    const vendors = [...root.querySelectorAll('[data-bb-vendor]')];
    const availability = [...root.querySelectorAll('[data-bb-available]')];
    const minimum = root.querySelector('[data-bb-min-price]');
    const maximum = root.querySelector('[data-bb-max-price]');
    const count = root.querySelector('[data-bb-result-count]');
    const filters = root.querySelector('.bb-filters');
    const openButton = root.querySelector('[data-bb-filter-open]');
    const closeButtons = [...root.querySelectorAll('[data-bb-filter-close]')];
    const backdrop = root.querySelector('.bb-filter-backdrop');
    const setFilterOpen = open => {
      filters?.toggleAttribute('data-bb-open', open);
      openButton?.setAttribute('aria-expanded', String(open));
      if (backdrop) backdrop.hidden = !open;
      document.documentElement.classList.toggle('bb-filter-lock', open);
    };
    openButton?.addEventListener('click', () => setFilterOpen(true));
    closeButtons.forEach(button => button.addEventListener('click', () => setFilterOpen(false)));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && filters?.hasAttribute('data-bb-open')) setFilterOpen(false);
    });
    const apply = () => {
      const selectedVendors = vendors.filter(input => input.checked).map(input => input.value);
      const inStockOnly = availability.some(input => input.checked);
      const min = minimum?.value === '' ? null : Number(minimum?.value);
      const max = maximum?.value === '' ? null : Number(maximum?.value);
      let visible = 0;
      for (const card of cards) {
        const price = Number(card.dataset.price);
        const show = (!selectedVendors.length || selectedVendors.includes(card.dataset.vendor)) && (!inStockOnly || card.dataset.available === 'true') && (min === null || price >= min) && (max === null || price <= max);
        card.hidden = !show;
        if (show) visible++;
      }
      if (count) count.textContent = String(visible);
    };
    root.querySelectorAll('.bb-filters input').forEach(input => input.addEventListener('change', apply));
    minimum?.addEventListener('input', apply);
    maximum?.addEventListener('input', apply);
    root.querySelector('[data-bb-clear]')?.addEventListener('click', () => {
      root.querySelectorAll('.bb-filters input').forEach(input => { input.checked = false; if (input.type === 'number') input.value = ''; });
      apply();
      if (matchMedia('(max-width: 700px)').matches) setFilterOpen(false);
    });
  };
  document.querySelectorAll('[data-bb-collection]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bb-collection]').forEach(setup));
})();
